<template>
  <div class="gallery-area pt-100 pb-100">
    <div class="container">
      <div class="section-title">
        <span class="sub-title">
          <i class="flaticon-hashtag-symbol"></i>
          {{ $t('gallery_span') }}
        </span>
        <h2>{{ $t('gallery_h2') }}</h2>
        <p ref="sectionTopNextPrevious">{{ $t('gallery_p') }}</p>
      </div>

      <!-- Side-by-side layout -->
      <div class="gallery-list-tab">
        <!-- Filter Sidebar -->
        <div class="tabs__header">
          <ul>
            <li :class="{ active: activeCategory === null }">
              <button @click="showAllPhotos">
                {{ $t('gallery_show_all') }}
              </button>
            </li>
            <li
              v-for="(category, index) in uniqueCategories"
              :key="index"
              :class="{ active: activeCategory === category }"
            >
              <button @click="filterPhotos(category)">
                {{ category }}
              </button>
            </li>
          </ul>
        </div>

        <!-- Gallery Grid -->
        <div class="gallery-grid">
          <div class="row">
            <div
              class="col-md-4"
              v-for="(photo, index) in displayedPhotos"
              :key="index"
            >
              <div
                class="single-gallery"
                @click="openImage(index)"
                style="cursor: pointer;"
              >
                <img :src="photo.url" :alt="'Photo ' + (index + 1)" />
                <p>{{ photo.category }}</p>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <div class="pagination" v-if="showPagination">
            <button @click="prevPage" :disabled="currentPage === 1">
              {{ $t('gallery_button_previous') }}
            </button>
            <span>
              {{ $t('gallery_page') }} {{ currentPage }} {{ $t('gallery_from') }} {{ totalPages }}
            </span>
            <button @click="nextPage" :disabled="currentPage === totalPages">
              {{ $t('gallery_button_next') }}
            </button>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div v-if="isOpen" class="image-overlay" @click="closeImage"></div>

      <div v-if="isOpen" class="image-modal" @click.stop>
        <span class="close-button" @click="closeImage">✕</span>
        <img
          :src="photos[openIndex].url"
          :alt="'Photo ' + (openIndex + 1)"
          class="modal-image"
          @click="nextImage"
        />
        <button class="nav-button prev" @click="prevImage">&lt;</button>
        <button class="nav-button next" @click="nextImage">&gt;</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LargeScreenGalleryLayout',
  data() {
    return {
      photos: [
        { url: require('@/assets/images/services/zirc-veneers/clients/veneers.webp'), category: this.$t('gallery_veneers') },
        { url: require('@/assets/images/services/zirc-veneers/clients/zv1.webp'), category: this.$t('gallery_veneers') },
        { url: require('@/assets/images/services/zirc-veneers/clients/veneers_one.webp'), category: this.$t('gallery_veneers') },
        { url: require('@/assets/images/services/zirc-veneers/clients/veneers_two.webp'), category: this.$t('gallery_veneers') },

        { url: require('@/assets/images/services/zircCrowns/zirconia_client.webp'), category: this.$t('gallery_veneers') },

        { url: require('@/assets/images/services/whitening/clients/whitening.webp'), category: this.$t('gallery_whitening') },

        { url: require('@/assets/images/services/hollywoodSmile/clients/hs.webp'), category: this.$t('gallery_hsmile') },

        { url: require('@/assets/images/services/allOnX/clients/allx.webp'), category: this.$t('gallery_allx') },
        { url: require('@/assets/images/services/allOnX/clients/fullmouth.webp'), category: this.$t('gallery_allx') },
        { url: require('@/assets/images/services/allOnX/clients/full_mouth_two.webp'), category: this.$t('gallery_allx') },

        { url: require('@/assets/images/services/hollywoodSmile/clients/hs1.webp'), category: this.$t('gallery_hsmile') },

        { url: require('@/assets/images/services/bridges/clients/bridges_client_one.webp'), category: this.$t('gallery_zbridges') },
        { url: require('@/assets/images/services/bridges/clients/bridges_client.webp'), category: this.$t('gallery_zbridges') },
        { url: require('@/assets/images/services/bridges/clients/bridges_client_two.webp'), category: this.$t('gallery_zbridges') },
        { url: require('@/assets/images/services/bridges/clients/bridges.webp'), category: this.$t('gallery_zbridges') },


        { url: require('@/assets/images/services/denture/clients/denture.webp'), category: this.$t('gallery_denture') },
        { url: require('@/assets/images/services/denture/clients/partial_dentures.webp'), category: this.$t('gallery_denture') },

        { url: require('@/assets/images/services/denture/clients/denture_one.webp'), category: this.$t('gallery_denture') },
        { url: require('@/assets/images/services/denture/clients/denture_two.webp'), category: this.$t('gallery_denture') },

        { url: require('@/assets/images/services/full-mouth-rehab/clients/full_mouth1.webp'), category: this.$t('gallery_rehab') },
        { url: require('@/assets/images/services/full-mouth-rehab/clients/fullmouth_one.webp'), category: this.$t('gallery_rehab') },
        { url: require('@/assets/images/services/full-mouth-rehab/clients/full_mouth_three.webp'), category: this.$t('gallery_rehab') },

        { url: require('@/assets/images/services/bruxismSplints/bruxismsplints.webp'), category: this.$t('gallery_bruxism_splint') },

        { url: require('@/assets/images/services/invisible-orthodontics/clients/patient1.webp'), category: this.$t('gallery_invisible_orthodontics') },
        { url: require('@/assets/images/services/invisible-orthodontics/clients/patient.webp'), category: this.$t('gallery_invisible_orthodontics') },
        { url: require('@/assets/images/services/dentalDesires/dental_desires.webp'), category: this.$t('gallery_dental_desires') },

      ],
      activeCategory: null,
      currentPage: 1,
      itemsPerPage: 6,

      // Modal data
      isOpen: false,
      openIndex: null,
    };
  },
  computed: {
    showPagination() {
      if (!this.activeCategory) {
        return true;
      } else {
        return this.photos.filter(photo => photo.category === this.activeCategory).length >= this.itemsPerPage;
      }
    },
    uniqueCategories() {
      return [...new Set(this.photos.map(photo => photo.category))];
    },
    filteredPhotos() {
      if (!this.activeCategory) return this.photos;
      return this.photos.filter(photo => photo.category === this.activeCategory);
    },
    totalPages() {
      return Math.ceil(this.filteredPhotos.length / this.itemsPerPage);
    },
    displayedPhotos() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredPhotos.slice(startIndex, startIndex + this.itemsPerPage);
    },
  },
  methods: {
    filterPhotos(category) {
      this.activeCategory = category;
      this.currentPage = 1;
      this.scrollToTop();
    },
    showAllPhotos() {
      this.activeCategory = null;
      this.currentPage = 1;
      this.scrollToTop();
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.scrollToTop();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.scrollToTop();
      }
    },
    scrollToTop() {
      const sectionTopNextPrevious = this.$refs.sectionTopNextPrevious;
      if (sectionTopNextPrevious) {
        sectionTopNextPrevious.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },

    // Modal methods
    openImage(index) {
      const photo = this.displayedPhotos[index];
      this.openIndex = this.photos.findIndex(p => p.url === photo.url);
      this.isOpen = true;
    },
    closeImage() {
      this.isOpen = false;
      this.openIndex = null;
    },
    prevImage() {
      if (this.openIndex > 0) {
        this.openIndex--;
      } else {
        this.openIndex = this.photos.length - 1;
      }
    },
    nextImage() {
      if (this.openIndex < this.photos.length - 1) {
        this.openIndex++;
      } else {
        this.openIndex = 0;
      }
    },
  },
};
</script>

